import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

if (!window._rails_loaded) Rails.start()
Turbolinks.start()
ActiveStorage.start()
